<template>
  <div v-clickoutside="$_handleClose" :class="classes">
    <t-caspanel
      v-show="!filterable || (filterable && query === '')"
      ref="caspanel"
      :prefix-class="prefixCardClass"
      :data="data"
      :disabled="disabled"
      :change-on-select="changeOnSelect"
      :size="size"
      :filterable="filterable"
      :clearable="clearable"></t-caspanel>
  </div>
</template>
<script>
import { PREFIX_CLASS } from '../../utils/constants'
import TCaspanel from './caspanel.vue'
import clickoutside from '../../directives/clickoutside'
import Emitter from '../../mixins/emitter'
import locale from '../../mixins/locale'
import { t } from '../../locale'

const PREFIX_CASCADER_CLASS = `${PREFIX_CLASS}cascader`

export default {
  name: 'TCascader',
  components: { TCaspanel },
  directives: { clickoutside },
  mixins: [locale, Emitter],
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    value: {
      type: Array,
      default() {
        return []
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default () {
        return t('t.cascader.placeholder')
      }
    },
    size: {
      type: String,
      validator(value) {
        return ['sm', 'lg'].includes(value)
      }
    },
    changeOnSelect: {
      type: Boolean,
      default: false
    },
    renderFormat: {
      type: Function,
      default(label) {
        return label.join(' / ')
      }
    },
    loadData: {
      type: Function
    },
    filterable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      clearable: false,
      visible: false,
      selected: [],
      tmpSelected: [],
      updatingValue: false, // to fix set value in changeOnSelect type
      currentValue: this.value,
      query: ''
    }
  },
  computed: {
    prefixCardClass() {
      return PREFIX_CASCADER_CLASS
    },
    classes() {
      return [
        `${PREFIX_CASCADER_CLASS}`,
        {
          [`${PREFIX_CASCADER_CLASS}-disabled`]: this.disabled
        }
      ]
    },
    displayRender() {
      let label = []
      for (let i = 0; i < this.selected.length; i++) {
        label.push(this.selected[i].label)
      }

      return this.renderFormat(label, this.selected)
    }
  },
  watch: {
    visible(val) {
      if (val) {
        if (this.currentValue.length) {
          this.$_updateSelected()
        }
      }
      this.$emit('on-visible-change', val)
    },
    value(val) {
      this.currentValue = val
      if (!val.length) this.selected = []
    },
    currentValue() {
      this.$emit('input', this.currentValue)
      if (this.updatingValue) {
        this.updatingValue = false
        return
      }
      this.$_updateSelected(true)
    },
    data: {
      deep: true,
      handler() {
        this.$nextTick(() => this.$_updateSelected())
      }
    }
  },
  mounted() {
    this.$_updateSelected(true)
  },
  created() {
    this.$on('on-result-change', params => {
      // lastValue: is click the final val
      // fromInit: is this emit from update value
      const lastValue = params.lastValue
      const changeOnSelect = params.changeOnSelect
      const fromInit = params.fromInit

      if (lastValue || changeOnSelect) {
        const oldVal = JSON.stringify(this.currentValue)
        this.selected = this.tmpSelected

        let newVal = []
        this.selected.forEach(item => {
          newVal.push(item.value)
        })

        if (!fromInit) {
          this.updatingValue = true
          this.currentValue = newVal
          this.$_emitValue(this.currentValue, oldVal)
        }
      }
      if (lastValue && !fromInit) {
        this.$_handleClose()
      }
    })
  },
  methods: {
    clearSelect() {
      if (this.disabled) return false
      let oldVal = JSON.stringify(this.currentValue)
      this.currentValue = this.selected = this.tmpSelected = []
      this.$_handleClose()
      this.$_emitValue(this.currentValue, oldVal)
      // this.$broadcast('on-clear');
      this.broadcast('TCaspanel', 'on-clear')
    },
    $_handleClose() {
      this.visible = false
    },
    toggleOpen() {
      if (this.disabled) return false
      if (this.visible) {
        if (!this.filterable) this.$_handleClose()
      } else {
        this.$_onFocus()
      }
    },
    $_onFocus() {
      this.visible = true
      if (!this.currentValue.length) {
        this.broadcast('TCaspanel', 'on-clear')
      }
    },
    updateResult(result) {
      this.tmpSelected = result
    },
    $_updateSelected(init = false) {
      if (!this.changeOnSelect || init) {
        this.broadcast('TCaspanel', 'on-find-selected', {
          value: this.currentValue
        })
      }
    },
    $_emitValue(val, oldVal) {
      if (JSON.stringify(val) !== oldVal) {
        this.$emit(
          'on-change',
          this.currentValue,
          JSON.parse(JSON.stringify(this.selected))
        )
        this.$nextTick(() => {
          this.dispatch('FormItem', 'on-form-change', {
            value: this.currentValue,
            selected: JSON.parse(JSON.stringify(this.selected))
          })
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// cascader.vue?1c3c406c